import SalariePrenom from '@/generated/controls/salarie/SalariePrenom.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SalariePrenom
})